/**
 * Composable for handling URL generation and query string building
 */

export function useUrlHelpers() {
  const getFilmDetailUrl = (slug) => {
    return slug ? `/film/${slug}` : "#";
  };

  const buildQueryString = (filters = {}) => {
    const queryString = new URLSearchParams();

    Object.keys(filters).forEach((key) => {
      if (Array.isArray(filters[key])) {
        filters[key].forEach((value) => queryString.append(`${key}[]`, value));
      } else {
        queryString.append(key, filters[key]);
      }
    });

    return queryString.toString();
  };

  return {
    getFilmDetailUrl,
    buildQueryString,
  };
}
